import React, { Fragment, memo } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
export function Footer() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatchTab = (tab: string) => {
    // Persist the desired tab so ColeccionesTabs can pick it up even if it
    // mounts/remounts after navigation (covers coming from another page).
    try {
      window.sessionStorage.setItem('savia:pendingTab', tab);
    } catch {
      // ignore storage errors
    }
    window.dispatchEvent(new CustomEvent('savia:tab', {
      detail: tab
    }));
  };
  const scrollToColecciones = () => {
    const target = document.getElementById('colecciones');
    const nav = document.getElementById('nav');
    if (target) {
      const offset = (nav?.offsetHeight ?? 0) + 24;
      window.scrollTo({
        top: target.getBoundingClientRect().top + window.scrollY - offset,
        behavior: 'smooth'
      });
    }
  };
  // Scroll to the "Más allá / Kits & Objetos" section using the SAME landing
  // point as the top nav "Kits & Objetos" button (nav offset + 120).
  const scrollToMasAlla = () => {
    const target = document.getElementById('mas-alla');
    const nav = document.getElementById('nav');
    if (target) {
      const offset = (nav?.offsetHeight ?? 0) + 24;
      window.scrollTo({
        top: target.getBoundingClientRect().top + window.scrollY - offset + 120,
        behavior: 'smooth'
      });
    }
  };
  const goToMasAlla = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
      window.setTimeout(scrollToMasAlla, 200);
      return;
    }
    scrollToMasAlla();
  };
  // Switch the collections tab AND scroll to the collections section on every
  // click, whether we're already on home or arriving from another page.
  const goToColeccion = (e: React.MouseEvent<HTMLAnchorElement>, tab: string) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      // From another page: navigate home, then activate + scroll once mounted.
      dispatchTab(tab);
      navigate('/');
      window.setTimeout(() => {
        dispatchTab(tab);
        scrollToColecciones();
      }, 200);
      return;
    }
    // Already on home: activate the tab and scroll right away.
    dispatchTab(tab);
    // Re-dispatch shortly after in case the section is still settling.
    window.setTimeout(() => dispatchTab(tab), 120);
    scrollToColecciones();
  };
  return <footer className="footer" data-id="element-109">
      <div className="savia-container" data-id="element-110">
        <div className="footer__grid" data-id="element-111">
          <div data-id="element-112">
            <Link to="/" className="footer__logo" data-id="element-113">
              SAVIA
            </Link>
            <span className="footer__tagline" data-id="element-114">
              Hecho para habitar en silencio.
            </span>
            <p className="footer__desc" data-id="element-115">
              Velas artesanales de cera de soya 100% vegetal. Hechas a mano en
              Bogotá. Enviamos a toda Colombia con la misma intención con que
              hacemos cada pieza.
            </p>
          </div>
          <div data-id="element-116">
            <span className="footer__col-title" data-id="element-117">Colecciones</span>
            <ul className="footer__links" data-id="element-118">
              <li data-id="element-119">
                <Link to="/#colecciones" onClick={e => goToColeccion(e, 'origen')} data-id="element-120">
                  Origen
                </Link>
              </li>
              <li data-id="element-121">
                <Link to="/#colecciones" onClick={e => goToColeccion(e, 'memoria')} data-id="element-122">
                  Memoria
                </Link>
              </li>
              <li data-id="element-123">
                <Link to="/#colecciones" onClick={e => goToColeccion(e, 'pausa')} data-id="element-124">
                  Pausa
                </Link>
              </li>
              <li data-id="element-125">
                <Link to="/#mas-alla" onClick={goToMasAlla} data-id="element-126">
                  Fragmentos
                </Link>
              </li>
              <li data-id="element-127">
                <Link to="/#mas-alla" onClick={goToMasAlla} data-id="element-128">
                  SAVIA Forma
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-129">
            <span className="footer__col-title" data-id="element-130">Información</span>
            <ul className="footer__links" data-id="element-131">
              <li data-id="element-132">
                <Link to="/#nosotros" data-id="element-133">Nosotros</Link>
              </li>
              <li data-id="element-134">
                <Link to="/pages/envios-devoluciones" data-id="element-135">
                  Envíos & Devoluciones
                </Link>
              </li>
              <li data-id="element-136">
                <Link to="/pages/preguntas-frecuentes" data-id="element-137">
                  Preguntas frecuentes
                </Link>
              </li>
              <li data-id="element-138">
                <Link to="/pages/politica-de-privacidad" data-id="element-139">
                  Política de privacidad
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-140">
            <span className="footer__col-title" data-id="element-141">Contacto</span>
            <ul className="footer__links" data-id="element-142">
              <li data-id="element-143">
                <a href="https://instagram.com/savia.ritualco" target="_blank" rel="noopener noreferrer" data-id="element-144">
                  @savia.ritualco
                </a>
              </li>
              <li data-id="element-145">
                <a href="https://wa.me/573213396782" target="_blank" rel="noopener noreferrer" data-id="element-146">
                  WhatsApp
                </a>
              </li>
              <li data-id="element-147">
                <span className="footer__text-plain" data-id="element-148">saviacolombia.com</span>
              </li>
              <li data-id="element-149">
                <span className="footer__text-plain" data-id="element-150">Bogotá, Colombia</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer__bottom" data-id="element-151">
          <p className="footer__copy" data-id="element-152">
            © {new Date().getFullYear()} SAVIA · Todos los derechos reservados
          </p>
          <p className="footer__made" data-id="element-153">Hecho en Colombia · Con intención</p>
        </div>
      </div>
    </footer>;
}